export enum GoalType {
  NET_ZERO = 'NET_ZERO',
  CARBON = 'CARBON',
  OTHER = 'OTHER',
}
export enum VerifyType {
  YES = 'YES',
  NO = 'NO',
}
export enum SubcommitteeType {
  OTHER_SUBCOMMITTEE = 'OTHER_SUBCOMMITTEE',
  AUDIT_COMMITTEE = 'AUDIT_COMMITTEE',
  EXECUTIVE_COMMITTEE = 'EXECUTIVE_COMMITTEE',
}

export enum CommitteeType {
  BOARD_OF_DIRECTOR = 'BOARD_OF_DIRECTOR',
  SUBCOMMITTEE = 'SUBCOMMITTEE',
}

export enum OrganizationType {
  GHG_MGNT_ORGANIZATION = 240,
  OTHER_GHG_MGNT_ORGANIZATION = 241,
}

export enum VerifierType {
  GHG_VERIFIER_OTHER_ID = 260,
}
export enum climateChangeGovernanceType {
  CLIMATE_CHANGE_GOVERNANCE = 825,
}
